export const organization = {
  name: 'SOWING HOPE FOUNDATION INC',
  shortName: 'Sowing Hope',
  location: 'West Manchester, Ohio',
  address: '759 Stephens Rd, W Manchester, OH 45382-9716',
};

export const navigation = [
  { label: 'Home', href: '#home' },
  { label: 'Story', href: '#story' },
  { label: 'Principles', href: '#principles' },
  { label: 'Future', href: '#future' },
  { label: 'Contact', href: '#contact' },
];

export const hero = {
  eyebrow: 'A foundation beginning with care',
  title: 'Planting a public place for hope to take root.',
  body: 'SOWING HOPE FOUNDATION INC is preparing a simple, accurate public presence for community members and future partners in West Manchester, Ohio.',
  primaryCta: { label: 'Find the address', href: '#contact' },
  secondaryCta: { label: 'Read the story', href: '#story' },
};

export const fieldNotes = [
  { label: 'Public identity', value: 'Foundation record' },
  { label: 'Home base', value: organization.location },
  { label: 'MVP scope', value: 'Static information only' },
];

export const story = {
  eyebrow: 'Story',
  title: 'A careful first page, not a finished narrative.',
  body: 'The available source confirms the foundation identity and public address. Until approved mission, leadership, and program details are available, this website avoids invented claims and keeps the message honest.',
};

export const principles = [
  {
    title: 'Sow before scaling',
    body: 'Start with a trustworthy foundation page, then add programs and outreach only when details are confirmed.',
  },
  {
    title: 'Keep public records clean',
    body: 'Show the verified address. Keep registry-only identifiers out of public pages and bundled assets.',
  },
  {
    title: 'Design for updates',
    body: 'Use modular sections and copy data so future mission, board, or initiative details can be added without a rebuild of the visual system.',
  },
];

export const futureUpdates = [
  'Approved mission statement',
  'Program and service details',
  'Leadership or board information',
  'Public contact channels when ready',
];

export const contact = {
  eyebrow: 'Contact',
  title: 'Grounded in West Manchester.',
  body: 'The first release keeps contact simple and static. No forms, donations, analytics, or personal data collection are included.',
};
